import { uniqBy } from "lodash";
import { SchemaReference } from "./graphql/types";

export const propertyName = (name: string) => {
  if (!name) {
    return "";
  }
  const cleanName = lettersOnly(name);
  return cleanName[0].toLowerCase() + cleanName.slice(1);
};

export const subjectName = (name: string) => {
  if (!name) {
    return "";
  }
  const cleanName = lettersOnly(name);
  return cleanName[0].toUpperCase() + cleanName.slice(1);
};

const lettersOnly = (string: string) => string.replace(/[^a-zA-Z]/g, "");

export const uniqueSchemaReferences = (references: SchemaReference[]) =>
  uniqBy(references, (value) => `${value.namespace}/${value.name}`);
